if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		#qty;

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			this.#qty = qty;

			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}
					this.#updateButtonPrice();
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
					this.#updateButtonPrice();
				}
			});

			qty.addEventListener('change', ()=>{
				this.#updateButtonPrice();
			});

			document.addEventListener('krown:variant:change', (e)=>{
				if ( e.detail.productForm && e.detail.productForm.contains(this) ) {
					this.#updateButtonPrice();
				}
			});

		}

		#updateButtonPrice() {

			const buttonPrice = this.#buttonPrice();

			if ( ! buttonPrice ) {
				return;
			}

			const unitPrice = parseInt(buttonPrice.dataset.unitPrice, 10),
						quantity = parseInt(this.#qty.value, 10);

			if ( isNaN(unitPrice) || isNaN(quantity) ) {
				return;
			}

			buttonPrice.innerHTML = KROWN.functions.formatMoney(unitPrice * quantity, KROWN.settings.shop_money_format) + KROWN.settings.iso_code;

		}

		#buttonPrice() {

			const holder = this.closest('.flex-buttons');

			return holder ? holder.querySelector('[data-js-atc-price]') : null;

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}
